import dynamic from "next/dynamic";
import { css } from "styled-components";
import tw from "twin.macro";
import { Achievement } from "../../types";

const Skeleton = dynamic(
  async () => (await import("../atoms/Skeleton")).Skeleton
);

const textCss = tw`font-semibold text-xs tracking-[.3px]`;

const emptyData = [...Array(4)];

interface Props {
  data: Achievement[];
  className?: string;
}

export const AchievementTable = ({ data = emptyData, className }: Props) => {
  return (
    <div
      tw="w-full bg-gray rounded-lg flex items-center flex-wrap"
      className={className}
    >
      {data.map((row, index) => (
        <div
          key={index}
          tw="flex items-center justify-between flex-nowrap w-1/2 p-[14px] box-border"
          css={css({ flex: "unset" })}
        >
          {row?.title ? (
            <h5 tw="font-base text-xs leading-none" css={textCss}>
              {row?.title}
            </h5>
          ) : (
            <Skeleton tw="w-1/3 h-3 rounded bg-[#eee]" />
          )}
          {["number", "string"].includes(typeof row?.value) ? (
            <p tw="text-theme" css={textCss}>
              {row?.value}
              {row?.unit}
            </p>
          ) : (
            <Skeleton tw="w-1/4 h-3 rounded bg-[#eee]" />
          )}
        </div>
      ))}
    </div>
  );
};
